module.exports = __webpack_public_path__ + "img/nursery7.f342a739.jpg";